const smartSandboxConfig = {
  fhirVersion: "4.0.1",
  clientId: "Smart on Fhir Sandbox",
  scopes: "launch openid fhirUser patient/*.read encounter/*.read communication/*.read",
  supportsBatch: false,
  welcomeMessage: "Welcome SMART Health IT Sandbox!",
  logo: "/images/logos/smart-logo.png",
  iss: "https://launch.smarthealthit.org/v/r4/fhir" // 🔗 FHIR base URL / issuer
};

export default smartSandboxConfig;